import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResponse } from '@otas/model/genericResponse';
import { ViewTemplePooja } from '@otas/model/pooja/view-temple-pooja';
import { ViewTempleMaterial } from '@otas/model/expense-head';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  public static templePoojas : Observable<GenericResponse<{ holidays: string[], list: ViewTemplePooja[], material:any }>> ;
  public static templePoojaList : ViewTemplePooja[];
  public static templeMaterials : ViewTempleMaterial[];
  public static templeHolidays: string[];

  constructor(private http: HttpClient) { }

  getTemplePoojas() {
    console.log('temple-pooja-inside-shared-service');
    SharedService.templePoojas = this.http.get<GenericResponse<{ holidays: string[], list: ViewTemplePooja[], material:any }>>(`temple/pooja`);
    SharedService.templePoojas.subscribe(response => {
      SharedService.templePoojaList = [];
      SharedService.templeHolidays = [];
      SharedService.templePoojaList = response.result.list;
      SharedService.templeHolidays = response.result.holidays;
    });
  }

  getTempleMaterial() {
    this.http.get<GenericResponse< ViewTemplePooja[]>>(`temple/saleable/material`).subscribe(response=>{
      SharedService.templeMaterials = [];
      SharedService.templeMaterials = response.result;
    });
  }

  deleteInvoice(invoiceIds: any[]): Observable<any> {
    return this.http.post<any>(`delete/invoice`, invoiceIds);
  }

  deleteInvoiceWithReason(invoiceIds: any[], reason: string): Observable<any> {
    return this.http.post<any>(`delete/invoice/${reason}`, invoiceIds);
  }

}
